import { Directive } from '@angular/core';

@Directive({
  selector: '[appOptionValue]'
})
export class OptionValueDirective { }
